import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useAddressConfiguration } from '../../context/AddressConfigurationContext/AddressConfigurationContext.js';
import Address$1 from './Address.js';
import { getAddressRows, parseAddress } from './utils.js';

const AddressContainer = (_param)=>{
    var { size ='COMPLETE' , data ={} , prepend  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "size",
        "data",
        "prepend"
    ]);
    const config = useAddressConfiguration();
    const rows = React__default.useMemo(()=>{
        const templateRows = getAddressRows(size, config);
        if (templateRows.length) {
            const addressRows = parseAddress(templateRows, data);
            if (prepend) {
                addressRows[0] = `${prepend}${addressRows[0]}`;
            }
            return addressRows;
        }
        const feedback = `No configuration for address size ${size}`;
        console.error(feedback);
        return [
            `[${feedback}]`
        ];
    }, [
        size,
        config,
        data,
        prepend
    ]);
    return /*#__PURE__*/ React__default.createElement(Address$1, swcHelpers.extends({}, rest, {
        rows: rows
    }));
};
var Address = AddressContainer;

export { Address as default };
//# sourceMappingURL=AddressContainer.js.map
